import React from 'react'
import { ExclamationTriangle} from 'react-bootstrap-icons'
import {useParams} from "react-router-dom";
import {InfoLg} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

/** Renders a component for the device status component, which displays a popover if there are any warnings, alarms or errors on the device
 * @param {string[]} deviceAlarms list of alarms for the device
 * @param {string[]} deviceWarnings list of warnings for the device
 * @param {string[]} hardwareErrors list of hardware errors for the device
 * @param {string[]} deviceProcesses List of device processes
 */
export default function DeviceStatusAbnormalities({
                                                      deviceAlarms,
                                                      deviceWarnings,
                                                      hardwareErrors,
                                                      deviceProcesses
                                                  }) {
    const {deviceSerialNumber} = useParams();
    const {t} = useTranslation(["dashboard", "telemetry"])

    function getAlarmTextOrLink(text) {
        if (text.toLocaleLowerCase() !== "filter alarm") return text
        return <a href={`/device/${deviceSerialNumber}/configurations/filter`}>{text}</a>
    }

    return (
        <div className='w-100 d-flex flex-wrap mt-1' style={{columnGap: '0.25rem', rowGap: '0.25rem'}}>
            {deviceProcesses.map(item => {
                const isExternalStop = item === "SysCon_ExternalStopProcess";
                return (
                    <div
                        key={t(`telemetry:${item}`)}
                        className={`rounded p-1 px-2 d-flex align-items-center columns3 ${isExternalStop ? "bg-danger-dim" : "bg-success-dim"}`}
                    >
                        <div
                            className='d-inline-block log-item-icon-sm'
                            style={{
                                color: isExternalStop ? "#a53333" : "darkgreen",
                                borderColor: isExternalStop ? "#a53333" : "darkgreen",
                                borderStyle: 'solid',
                                borderWidth: '1px'
                            }}
                        >
                            <InfoLg
                                width='15px'
                                height='15px'
                                viewBox='0 1 16 15'
                                style={{ verticalAlign: 'unset', color: isExternalStop ? "#a53333" : "darkgreen" }}
                            />
                        </div>
                        <span>&nbsp;{ t(`telemetry:${item}`) }</span>
                    </div>
                );
            })}
            {deviceAlarms.map(item => <div key={t(`telemetry:${item}`)}
                                           className='rounded p-1 px-2 d-flex align-items-center columns3 bg-danger-dim'>
                <ExclamationTriangle className='me-1 color-danger'/> {getAlarmTextOrLink(t(`telemetry:${item}`))}
            </div>)}
            {hardwareErrors.map(item => <div key={t(`telemetry:${item}`)}
                                             className='rounded p-1 px-2 d-flex align-items-center columns3 bg-warning-dim'>
                <ExclamationTriangle className='me-1 color-warning'/> {t(`telemetry:${item}`)}
            </div>)}
            {deviceWarnings.map(item => <div key={t(`telemetry:${item}`)}
                                             className='rounded p-1 px-2 d-flex align-items-center columns3 bg-warning-dim'>
                <ExclamationTriangle className='me-1'/> {item}
            </div>)}
        </div>
    )
}